<template>
  <div class="container-fluid bg-light">
    <div class="row title-card">
      <div class="col-10 text-left text-dark"><h4>Cadastro de Checks</h4></div>
      <div class="col-2 text-right"><b-link class="text-dark" :to="{ name: 'home' }"><icon name="times" scale="2"></icon></b-link></div>
    </div>
    <div class="row">
      <div class="col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3 offset-xl-3 text-right"><b-btn v-b-modal.novoCheck variant="success">Novo Check</b-btn></div>
    </div>
    <div class="row pt-2">
      <div class="col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3 offset-xl-3">
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">Nome</th>
              <th scope="col" class="text-right">Opções</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(check, index) in checks" v-bind:key="'check-'+index">
              <td class="align-middle text-truncate">{{ check.nm_check }}</td>
              <td>
                <div class="btn-toolbar float-right" role="toolbar">
                  <div class="btn-group" role="group">
                    <button type="button" class="btn btn-primary" @click="setCheck(check)" v-b-modal.editarCheck>
                        <icon name="pencil" scale="1.2" class="align-middle"></icon>
                    </button>
                    <b-button v-b-tooltip.hover class="btn btn-success" @click="changeStatus(check)" v-if="check.st_check == '1'" title="Desativar">
                        <icon name="check" scale="1.2" class="align-middle"></icon>
                    </b-button>
                    <b-button v-b-tooltip.hover class="btn btn-danger" @click="changeStatus(check)" v-if="check.st_check == '0'" title="Ativar">
                        <icon name="ban" scale="1.2" class="align-middle"></icon>
                    </b-button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal Nova Loja -->
    <b-modal id="novoCheck" ref="modalNew" title="Novo Check" @ok="newCheck" @hidden="clearData" no-close-on-backdrop>
      <form @submit="onSubmit">
        <div class="form-group">
          <label for="grupo">Grupo</label>
          <select class="custom-select" v-model="novoCheck.grupo" required>
            <option v-for="(group, index) in groups" v-bind:key="'group-'+index" v-bind:value="group.id_group">{{ group.nm_group }}</option>
          </select>
        </div>
        <div class="form-group">
          <label for="modelo">Modelo de Check</label>
          <select class="custom-select" v-model="novoCheck.modelo" required>
            <option v-for="(model, index) in models" v-bind:key="'model-'+index" v-bind:value="model.id_model">{{ model.nm_model }}</option>
          </select>
        </div>
        <div class="form-group">
          <label for="nomeCheck">Nome</label>
          <input type="text" class="form-control" id="nomeCheck" v-model="novoCheck.nome" required>
        </div>
        <div class="form-group">
          <label for="descCheck">Descrição</label>
          <textarea v-model="novoCheck.descricao" class="form-control" id="descCheck" rows="3" maxlength="1000" required></textarea>
        </div>
        <div class="form-row">
          <div class="form-group col-6">
            <label for="freqCheck">Frequência (dias)</label>
            <the-mask :mask="['###', '##']" class="form-control" id="freqCheck" v-model="novoCheck.frequencia" required/>
          </div>
          <div class="form-group col-6">
            <label for="pesoCheck">Peso</label>
            <the-mask :mask="['###.##', '##.##', '#.##']" class="form-control" masked="true" id="pesoCheck" v-model="novoCheck.peso" required></the-mask>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- Modal Editar Loja -->
    <b-modal id="editarCheck" ref="modalEdit" title="Editar Check" @ok="editCheck" @hidden="clearData" no-close-on-backdrop>
      <form @submit="onSubmit">
        <div class="form-group">
          <label for="grupo">Grupo</label>
          <select class="custom-select" v-model="editarCheck.grupo" required>
            <option v-for="(group, index) in groups" v-bind:key="'group-'+index" v-bind:value="group.id_group">{{ group.nm_group }}</option>
          </select>
        </div>
        <div class="form-group">
          <label for="modelo">Modelo de Check</label>
          <select class="custom-select" v-model="editarCheck.modelo" required>
            <option v-for="(model, index) in models" v-bind:key="'model-'+index" v-bind:value="model.id_model">{{ model.nm_model }}</option>
          </select>
        </div>
        <div class="form-group">
          <label for="nomeCheck">Nome</label>
          <input type="text" class="form-control" id="nomeCheck" v-model="editarCheck.nome" required>
        </div>
        <div class="form-group">
          <label for="descCheck">Descrição</label>
          <textarea v-model="editarCheck.descricao" class="form-control" id="descCheck" rows="3" maxlength="1000" required></textarea>
        </div>
        <div class="form-row">
          <div class="form-group col-6">
            <label for="freqCheck">Frequência (dias)</label>
            <the-mask :mask="['###', '##']" class="form-control" id="freqCheck" v-model="editarCheck.frequencia" required/>
          </div>
          <div class="form-group col-6">
            <label for="pesoCheck">Peso</label>
            <the-mask :mask="['###.##', '##.##', '#.##']" class="form-control" type="tel" id="pesoCheck" v-model="editarCheck.peso" required></the-mask>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { http } from '../http'
import { TheMask } from 'vue-the-mask'
import swal from 'sweetalert'
import Icon from 'vue-awesome'

export default {
  components: { Icon, TheMask },
  data () {
    return {
      level: localStorage.getItem('level'),
      admin: localStorage.getItem('admin'),
      novoCheck: { grupo: null, nome: null, descricao: null, frequencia: null, peso: null, modelo: null },
      editarCheck: { check:null, grupo: null, nome: null, descricao: null, frequencia: null, peso: null, status: null, modelo: null },
      groups: [],
      models: [],
      checks: [],
      txt:''
    }
  },
  beforeCreate () {
    // Verifica se existe o item token no localStorage.
    if (!localStorage.getItem('token')) this.$router.push('home')
    if (localStorage.getItem('admin') == 'false') this.$router.push('home')
  },
  mounted () {
    http.get('/checks/all').then(response => { this.checks = response.data; console.log(this.checks); })
    http.get('/checks/groups').then(response => { this.groups = response.data; })
    http.get('/model/all').then(response => { this.models = response.data; })
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault();
    },
    newCheck (evt) {
      evt.preventDefault();
      if (!this.novoCheck.nome || !this.novoCheck.frequencia || !this.novoCheck.peso || !this.novoCheck.modelo) {
        swal({
          icon: 'error',
          title: 'Erro...',
          text: 'Informe o nome, a frequência e o peso do novo check.',
          dangerMode: true,
        })
      }
      else {
        var json = {
            id_group: this.novoCheck.grupo,
            nm_check: this.novoCheck.nome,
            ds_check: this.novoCheck.descricao,
            nr_freq: this.novoCheck.frequencia,
            nr_factor: this.novoCheck.peso,
            st_check: true,
            id_model: this.novoCheck.modelo};

        // Requisição para gravar o novo check.
        http.post('/checks/new', json)
          .then(response => {
            this.clearData()
            this.$refs.modalNew.hide()
            swal({
              icon: 'success',
              title: 'Ok!',
              text: 'Novo check cadastrado.'
            })
            http.get('/checks/all').then(response => { this.checks = response.data; })
          })
          .catch(error => {
            swal({
              type: 'error',
              title: 'Erro...',
              text: error.response.data.mensagem
            })
          })
      }
    },
    editCheck (evt) {
      evt.preventDefault();
      if (!this.editarCheck.nome || !this.editarCheck.frequencia || !this.editarCheck.peso || !this.editarCheck.modelo) {
        swal({
          icon: 'error',
          title: 'Erro...',
          text: 'Informe o nome, a frequência e o peso do novo check.',
          dangerMode: true,
        })
      }
      else {
        var json = {
            id_check: this.editarCheck.check,
            id_group: this.editarCheck.grupo,
            nm_check: this.editarCheck.nome,
            ds_check: this.editarCheck.descricao,
            nr_freq: this.editarCheck.frequencia,
            nr_factor: this.editarCheck.peso,
            st_check: this.editarCheck.status,
            id_model: this.editarCheck.modelo};

        // Requisição para gravar as alterações.
        http.post('/checks/update', json)
          .then(response => {
            this.clearData()
            this.$refs.modalEdit.hide()
            swal({
              icon: 'success',
              title: 'Ok!',
              text: 'Informações salvas.'
            })
            http.get('/checks/all').then(response => { this.checks = response.data; })
          })
      }
    },
    changeStatus (check) {
      if(check.st_check == 1){
          check.st_check = 0;
          this.txt = 'inativado';
      } else{
        check.st_check = 1;
        this.txt = 'Ativado';
      }

      var json = {
          id_check: check.id_check,
          id_group: check.id_group,
          nm_check: check.nm_check,
          ds_check: check.ds_check,
          nr_freq:  check.nr_freq,
          nr_factor:check.nr_factor,
          st_check: check.st_check,
          id_model: check.id_model};
        console.log(json);
      // Requisição para inativar o check.
      http.post('/checks/update', json)
        .then(response => {
          swal({
            icon: 'success',
            title: 'Salvo!',
            text: 'Check ' + this.txt + '.'
          })
          http.get('/checks/all').then(response => { this.checks = response.data; })
        })
        .catch(error => {
          swal({
            type: 'error',
            title: 'Erro...',
            text: error.response.data.mensagem
          })
        })
    },
    setCheck (check) {
      this.editarCheck.check      = check.id_check
      this.editarCheck.grupo      = check.id_group
      this.editarCheck.nome       = check.nm_check
      this.editarCheck.descricao  = check.ds_check
      this.editarCheck.frequencia = check.nr_freq
      this.editarCheck.peso       = check.nr_factor
      this.editarCheck.status     = check.st_check
      this.editarCheck.modelo     = check.id_model
    },
    clearData (evt) {
      this.novoCheck.grupo        = null
      this.novoCheck.nome         = null
      this.novoCheck.descricao    = null
      this.novoCheck.frequencia   = null
      this.novoCheck.peso         = null
      this.novoCheck.modelo       = null
      this.editarCheck.check      = null
      this.editarCheck.grupo      = null
      this.editarCheck.nome       = null
      this.editarCheck.descricao  = null
      this.editarCheck.frequencia = null
      this.editarCheck.peso       = null
      this.editarCheck.status     = null
      this.editarCheck.modelo     = null
    }
  }
}
</script>

<style scoped>
.container-fluid { min-height:100vh; }
.container-fluid .title-card { padding:20px 0; }
.container-fluid .title-card h4 { font-size:1.5em; line-height:40px; }
</style>



// WEBPACK FOOTER //
// src/components/Checks.vue